import { render } from "./CargoPalletInfoDialog.vue?vue&type=template&id=fc410a4e&ts=true"
import script from "./CargoPalletInfoDialog.vue?vue&type=script&lang=ts"
export * from "./CargoPalletInfoDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__